export const getFormDefaultValues = (publicRunnerImage?: string, privateRunnerImage?: string) => {
  return {
    publicWorkerPoolRunnerImage: publicRunnerImage || "",
    privateWorkerPoolRunnerImage: privateRunnerImage || "",
  };
};
